const UTM_COOKIE_YAMPI = "utmsTrack"
const UTM_TERMS_YAMPI = [
  "utm_source",
  "utm_campaign",
  "utm_term",
  "utm_medium",
  "utm_content",
]

const ADD_BTN_SELECTOR =
  'input[name="add"], button[name="add"], #add-to-cart, .add-to-cart, #AddToCartText, #AddToCart, .ProductForm__AddToCart'

const CHECKOUT_BTN_CSS = `<style id="ymp-btn-style">
  body .ymp-CrtpageMainFrm input[type="submit"]:not([name="update"]),
  body .ymp-CrtpageMainFrm button[type="submit"]:not([name="update"]),
  body .ymp_check_mainBtn[name="checkout"]:not([class*="ymp_elem_"]):not([name="update"]),
  body input.ymp_check_mainBtn:not([class*="ymp_elem_"]):not([name="update"]) { display: none !important; }
  body .ymp-CrtpageMainFrm .ymp_check_mainBtn.ymp_elem_mainBtn[type="submit"]:not(.bold_hidden) { display: inline-block !important; }
</style>`

// -- Loader --

const loader = document.getElementById("yampiLoader")

const showLoader = () => (loader.classList.add("active"))
const hideLoader = () => (loader.classList.remove("active"))

const closeCartDrawer = async () =>
  new Promise((resolve, reject) => {
    const drawer = document.querySelector("cart-drawer")

    if (!drawer) return reject(new Error("Cart drawer not found"))

    drawer.dispatchEvent(
      new CustomEvent("dialog:force-close", {
        bubbles: true,
        cancelable: true,
        composed: true,
      }),
    )

    resolve()
  })

// -- HTTP --

const fetchData = (url, options = {}) =>
  fetch(url, options).then((r) => {
    if (!r.ok) throw r.status
    return r.json()
  })

const http = {
  get: (url) =>
    fetchData(url, { headers: { "X-Requested-With": "XMLHttpRequest" } }),

  post: (url, data) =>
    fetchData(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(data),
    }),

  postForm: (url, form) =>
    fetchData(url, {
      method: "POST",
      body: new URLSearchParams(new FormData(form)),
    }),
}

// -- Cookies --

const Cookies = {
  get: (name) => {
    const prefix = `${name}=`
    return (
      document.cookie
        .split(";")
        .map((c) => c.trim())
        .find((c) => c.startsWith(prefix))
        ?.substring(prefix.length) ?? null
    )
  },

  set: (name, value, days) => {
    let expires = ""

    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = `; expires=${date.toUTCString()}`
    }

    document.cookie = `${name}=${value || ""}${expires}; path=/`
  },
}

// -- UTMs --

const getUtms = () => new URLSearchParams(Cookies.get(UTM_COOKIE_YAMPI) ?? "")

const setUtm = (term, value) => {
  const params = getUtms()
  params.set(term, value)
  Cookies.set(UTM_COOKIE_YAMPI, params.toString(), 30)
}

const getUrlWithUtms = (url) => {
  if (!url) return url
  const parsed = new URL(url)
  const ga = Cookies.get("_ga")
  getUtms().forEach((value, key) => parsed.searchParams.set(key, value))
  if (ga) parsed.searchParams.set("_ga", ga)
  return parsed.href
}

const { searchParams } = new URL(window.location.href)
UTM_TERMS_YAMPI.filter((t) => searchParams.has(t)).forEach((t) =>
  setUtm(t, searchParams.get(t)),
)

// -- Device detection --

const isFacebookBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera
  return ua.includes("FBAN") || ua.includes("FBAV")
}

const isAndroid = () => navigator.userAgent.toLowerCase().includes("android")

// -- Checkout --

window.yampiCheckoutUrl = ""

const fetchCheckoutUrl = (cartPayload, includeInternalDomain = false) => {
  const data = {
    shop: window.location.host,
    cart_payload: cartPayload,
    ...(includeInternalDomain && {
      shopify_internal_domain: __LTCO_YAMPI_CONFIG.shopInternal,
    }),
  }
  return http.post(__LTCO_YAMPI_CONFIG.endpoint.cart, data)
}

const redirectToCheckout = async () => {
  showLoader()

  const cart = await http.get("/cart.json")
  const { checkout_direct_url } = await fetchCheckoutUrl(cart)

  window.location.href = getUrlWithUtms(checkout_direct_url)

  setTimeout(async () => (await closeCartDrawer(), hideLoader()), 2000)
}

window.yampiClick = redirectToCheckout

window.getNewCheckoutURL = async () => {
  showLoader()

  const cart = await http.get("/cart.json")
  const { checkout_direct_url } = await fetchCheckoutUrl(cart)

  await http.post("/cart/clear.js", {})

  window.location.href = getUrlWithUtms(checkout_direct_url)

  hideLoader()
}

// -- Purchase confirmation --

const showPurchaseConfirmation = () => {
  document
    .getElementById("yampiPurchaseConfirmationWrapper")
    .classList.add("active")
  hideLoader()
}

document
  .getElementById("yampiPurchaseConfirmationButton")
  .addEventListener("click", window.getNewCheckoutURL)

// -- Cart page --

const initCart = async () => {
  showLoader()

  const cart = await http.get("/cart.json")
  const resp = await fetchCheckoutUrl(cart, true)

  if (!resp.active) {
    hideLoader()
    return
  }

  document
    .querySelectorAll(".cartX_check_mainBtn")
    .forEach((btn) => btn.setAttribute("style", "display: none !important"))

  window.yampiCheckoutUrl = resp.checkout_direct_url

  if (resp.skip_cart && resp.checkout_direct_url) {
    if (resp.fb_fallback && isAndroid() && isFacebookBrowser()) {
      window.location = getUrlWithUtms(resp.checkout_direct_url)
      setTimeout(showPurchaseConfirmation, 500)
    } else {
      await http.post("/cart/clear.js", {})
      window.location = getUrlWithUtms(resp.checkout_direct_url)
    }
    return
  }

  hideLoader()
  document.head.insertAdjacentHTML("beforeend", CHECKOUT_BTN_CSS)

  document.querySelectorAll("form").forEach((form) => {
    const parts = form.action.split(__LTCO_YAMPI_CONFIG.shop)
    if (!parts.includes("/cart") && !parts[0].includes("/cart")) return

    if (!form.id) form.id = "ymp-CrtpageMainFrm"
    form.classList.add("ymp-CrtpageMainFrm")

    const checkoutBtn =
      form.elements["checkout"] ||
      document.querySelector('a[href="/checkout"]') ||
      document.querySelector('form[action="/cart"] input[type="submit"]')

    if (!checkoutBtn) return

    const lastBtn = checkoutBtn.length ? checkoutBtn.at(-1) : checkoutBtn
    const newBtn = Object.assign(document.createElement("button"), {
      type: "submit",
      className: `${lastBtn.className} ymp_check_mainBtn ymp_elem_mainBtn`,
      id: lastBtn.id ? `${lastBtn.id}ympButton` : "ympBtn",
      textContent: lastBtn.value || lastBtn.textContent,
    })
    lastBtn.insertAdjacentElement("afterend", newBtn)
    newBtn.addEventListener("click", (e) => {
      e.preventDefault()
      redirectToCheckout()
    })
  })

  document
    .querySelectorAll('a.btn-checkout[href="/checkout"]:not(.ymp_elem_mainBtn)')
    .forEach((btn) => (btn.style.display = "none"))

  document
    .querySelectorAll('a[href="/a/checkout"]:not(.yampi-btn-finalize)')
    .forEach((link) => {
      link.classList.add("yampi-btn-finalize-single")
      link.addEventListener("click", (e) => {
        e.preventDefault()
        window.location.href = getUrlWithUtms(window.yampiCheckoutUrl)
      })
    })
}

// -- Product / Index page --

const initProductPage = async () => {
  document.querySelectorAll(".btn-checkout").forEach((btn) => {
    if (btn.getAttribute("onclick") === "window.location='/checkout'") {
      btn.setAttribute("onclick", "window.location='/cart'")
    }
  })

  const addBtns = [...document.querySelectorAll(ADD_BTN_SELECTOR)]
  addBtns.forEach((btn) => (btn.disabled = true))

  const resp = await http.get(
    `${__LTCO_YAMPI_CONFIG.endpoint.status}?shop=${window.location.host}`,
  )

  if (resp?.data?.active) {
    document.querySelectorAll(ADD_BTN_SELECTOR).forEach((btn) => {
      btn.classList.add("ymp_mainBtn", "ymp_elem_0")
      btn.disabled = false
      btn.addEventListener("click", async (event) => {
        event.preventDefault()
        const form = btn.closest('form[action="/cart/add"]')
        if (!form) return
        await http.postForm("/cart/add.js", form)
        window.location.href = "/cart?ref=yampi_buy_button"
      })
    })
  } else {
    addBtns.forEach((btn) => (btn.disabled = false))
  }
}

// -- Init --
if (__LTCO_YAMPI_CONFIG.currentPage === "cart") initCart()
if (
  __LTCO_YAMPI_CONFIG.currentPage === "product" ||
  __LTCO_YAMPI_CONFIG.currentPage === "index"
)
  initProductPage()
